import React, { useEffect, useState } from "react";
import api from "../lib/api";
import { fmtDate } from "../lib/format";
import { Card } from "../components/ui/card";
import { Badge } from "../components/ui/badge";
import { Table, TableHeader, TableBody, TableRow, TableHead, TableCell } from "../components/ui/table";

export default function AuditLog() {
  const [rows, setRows] = useState([]);
  useEffect(() => { api.get("/audit-log").then((r) => setRows(r.data)).catch(() => {}); }, []);
  return (
    <div className="space-y-5" data-testid="page-audit">
      <h1 className="text-3xl font-display font-bold text-primary">Audit Log</h1>
      <Card className="p-4">
        <div className="overflow-x-auto rounded-lg border">
          <Table>
            <TableHeader><TableRow className="bg-muted/50">
              <TableHead>Data/Ora</TableHead><TableHead>Utente</TableHead><TableHead>Azione</TableHead>
              <TableHead>Entità</TableHead><TableHead>Record</TableHead>
            </TableRow></TableHeader>
            <TableBody>
              {rows.map((r) => (
                <TableRow key={r.id}>
                  <TableCell className="whitespace-nowrap">{fmtDate(r.timestamp)}</TableCell>
                  <TableCell>{r.user}</TableCell>
                  <TableCell><Badge variant="outline">{r.action}</Badge></TableCell>
                  <TableCell>{r.entity}</TableCell>
                  <TableCell className="text-xs text-muted-foreground">{r.record_id}</TableCell>
                </TableRow>
              ))}
              {rows.length === 0 && <TableRow><TableCell colSpan={5} className="text-center py-6 text-muted-foreground">Nessuna voce</TableCell></TableRow>}
            </TableBody>
          </Table>
        </div>
      </Card>
    </div>
  );
}
